import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "@/data/content";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-shadow duration-300 glass-nav ${
        scrolled ? "shadow-[0_6px_24px_-16px_rgba(11,35,65,0.35)]" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo-link"
          className="flex items-center"
          onClick={() => setOpen(false)}
        >
          <img
            src="/maqam-logo.png"
            alt="Maqam Community Initiatives"
            className="h-9 md:h-11 w-auto"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-6">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors whitespace-nowrap ${
                  isActive ? "text-navy font-semibold" : "text-[var(--maqam-muted)] hover:text-navy"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-register-cta"
            className="btn-gold rounded-full px-5 py-2 text-sm font-semibold whitespace-nowrap"
          >
            Register Interest
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden p-2 text-navy"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-controls="mobile-nav-menu"
          aria-label={open ? "Close menu" : "Open menu"}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div id="mobile-nav-menu" data-testid="nav-mobile-menu" className="lg:hidden border-t border-[var(--maqam-border)] bg-white">
          <div className="px-5 py-4 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `py-3 px-2 text-base border-b border-[var(--maqam-border)] ${
                    isActive ? "text-navy font-semibold" : "text-[var(--maqam-muted)]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-register"
              className="btn-gold rounded-full px-5 py-3 mt-3 text-center font-semibold"
            >
              Register Interest
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
